
import BeneficiarioFormModel from "@/models/Sobrevivencia/BeneficiarioFormModel";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Accordion, AccordionItem } from "@/components/Accordion";
import FormBeneficiario from "@/components/sobrevivencia/FormBeneficiario.vue";
import Swal from "sweetalert2";
import PreguntaFormulario from '@/models/Sobrevivencia/Pregunta';

@Component({
  components: { Accordion, AccordionItem, FormBeneficiario },
})
 
export default class DatosBeneficiario extends Vue {
  @Prop() Pregunta: PreguntaFormulario;
  public Beneficiarios: Array<BeneficiarioFormModel> =
    new Array<BeneficiarioFormModel>();
     

  mounted() {
    var number = 3;
    for (var i = 0; i < number; i++) {
      let nuevoBeneficiario: BeneficiarioFormModel = new BeneficiarioFormModel(
        i,
        "Nombre" + i
      );
      this.Beneficiarios.push(nuevoBeneficiario);
    }
  }

  addBeneficiario(){
    let nuevoBeneficiario: BeneficiarioFormModel = new BeneficiarioFormModel()
    nuevoBeneficiario.id = this.Beneficiarios.length +1 ,
    nuevoBeneficiario.nombre = "Nuevo Bebenificario";
    this.Beneficiarios.push(nuevoBeneficiario);
  }

  removeBeneficiario(id:number){
    let index = this.Beneficiarios.findIndex( x=> x.id == id);
    this.Beneficiarios.splice(index,1);
  }
  public showDeleteAlert(id:number): void {
    Swal.fire({
      text: "Desea eliminar este beneficiario/a?",
       
      icon:"error",
      showCancelButton: true,
      confirmButtonColor: "#ED8B2F",
      cancelButtonColor: "#0F6CbC",
      confirmButtonText: "Sí",
      cancelButtonText: "No",
      
    }).then((result) => {
      if (result.isConfirmed) {
         
        Swal.fire({
          icon:"success",
          allowOutsideClick: false,
          showConfirmButton:false,
          timer:1000
         }).then((result) => {
           this.removeBeneficiario(id)
        });
      }
    });
  }

  public changeBeneficiario(value:BeneficiarioFormModel){
    // console.log(value)
    // console.log("changed")
      let index = this.Beneficiarios.findIndex( x=> x.id == value.id);
      // console.log(index);
      this.Beneficiarios[index].nombre= value.nombre;
  }
}
